import SandClockIcon from './component'

export default SandClockIcon
